import Vue from 'vue'
import App from './App.vue'
import router from "@/router/router.js"
import store from "@/store/store.js"
import myPlugin from "@/utils/myPlugin.js"
import ElementUI from 'element-ui';
import './element-variables.scss';
import vue2OrgTree from "vue2-org-tree"
import "vue2-org-tree/dist/style.css"
Vue.use(ElementUI);
Vue.use(myPlugin);
Vue.use(vue2OrgTree);
import "@/style/base.css";
import "@/style/global.less";
import "@/style/theme.less";
import "@/style/iconfont.css";
import "@/directives/directives.js";
import "@/utils/lastModuleMixin.js";
import { getTheme, applyTheme, applyMourning, applyDarkMode } from "@/utils/theme.js";

// 应用已保存的主题色（默认微信绿）
applyTheme(getTheme());
// 恢复护眼深色模式（独立于颜色主题）
applyDarkMode();
// 纪念日自动开启致哀模式（全站置灰）
applyMourning();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
